// Important: Put all overrides and enhancements of Core Fountatiomn functions here, and then initialize Foundation.

// Form Validators
// Checkbox validator (at least 1 must be selected), Markup is built here: /functions/gravityforms.php
function nkCheckboxLimit(el, required, parent) {
    var group = parent.closest('.gfield_checkbox');
    var form_error = '.form-error.' + parent.closest('.gfield_checkbox').attr('id');
    var min = 1;
    var checked = group.find(':checked').length;
    if (checked >= min) {
        // clear label highlight
        group.find('label').each(function() {
            jQuery(this).removeClass('is-invalid-label');
        });
        // clear checkbox error
        group.find(':checkbox').each(function() {
            jQuery(this).removeClass('is-invalid-input').removeAttr('data-invalid');
        });
        jQuery(form_error).removeClass('is-visible');
        return true;
    } else {
        // label highlight
        group.find('label').each(function() {
            jQuery(this).addClass('is-invalid-label');
        });
        // checkbox error
        group.find(':checkbox').each(function() {
            jQuery(this).addClass('is-invalid-input').attr('data-invalid');
        });
        jQuery(form_error).addClass('is-visible');
        return false;
    }
}

Foundation.Abide.defaults.validators.checkbox_limit = nkCheckboxLimit;

// Initialize Foundation

jQuery(document).foundation();